<template>
	<div>
		<h1 class="h2 text-uppercase">Services</h1>
		<p>HME Rotary can offer a complete health check to all MAZDA RX engined vehicles from 10A to 20B</p> 
		<b-row>
			<b-col>
				<ServiceCars car="MAZDA RX8 all models" image="rx8" sub_title="Including R3" image_alt="MAZDA RX8 R3 | MAZDA RX8 Engine"/>
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<ServiceCars car="MAZDA RX7" image="rx7" sub_title="FB, FC & FD" image_alt="MAZDA RX7 FD | RX7 FB 12A Engine"/>
			</b-col>
		</b-row>
		<b-row>
			<b-col>
				<ServiceCars car="N.S.U" image="nsu" sub_title="RO80" image_alt="NSU Ro80 | NSU Ro80 Demonstration Engine"/>
			</b-col>
			</b-row>
		<b-row>
			<b-col>
				<ServiceCars car="We have also rebuilt" image="classic" :show_list="false" image_alt="Citroen Bi/rotor | DKM Wankel-designed engine prototype"/>
			</b-col>
		</b-row>
	</div>
</template>
<script>
	import ServiceCars from './ServiceCars.vue'
export default {
  name: 'Services',
  props: {
    msg: String
  },
  components: {
ServiceCars,
  }
}
</script>